<style scoped lang="scss">
.icon-list {
  .lists {
    flex-wrap: wrap;
    justify-content: center;
    li {
      flex: none;
      margin-top: 10px;
      img {
        height: 120px;
      }
      p{
        white-space: pre-line;
        &.title{
          margin-top: 20px;
          font-size: 16px;
        }
        &.content{
          line-height: 1.6;
        }
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .icon-list .lists li {
    width: 100% !important;
    margin: 20px 0 !important;
  }
}
</style>
<template>
  <div class="icon-list container">
    <ul class="lists">
      <li
        v-for="(item, index) in iconList"
        :key="index"
        :style="{
          width: item.width ? item.width : 100 / (iconList.length / lines) + '%',
          marginTop: lines > 1 && index + 1 > iconList.length / lines ? '60px' : '10px',
        }"
      >
        <img
          :src="require(`@/assets/images/${item.img}.png`)"
          :alt="`擎科生物-${menuTitle}-${item.title}`"
        />
        <p class="title">{{ item.title }}</p>
        <p class="content" v-if="item.text">{{ item.text }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "application-icon",
  props: {
    lines: {
      type: Number,
      default: 1,
    },
    iconList: {
      type: Array,
    },
    menuTitle: {
      type: String,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/tec/components/applicationIcon.vue